module.exports = __webpack_public_path__ + "img/7.c48b5246.png";